import { useSuspenseQuery } from '@tanstack/react-query';
import { getTransactionSummaryReport } from 'bff/hooks/reporting/TransactionSummaryApi';
import TransactionSummaryDropdown from './transaction-summary-dropdown/TransactionSummaryDropdown';
import { StatementOption } from 'modules/clients/types/client.enum';
import { StatementProps } from 'modules/clients/types/client.types';
import { Suspense } from 'react';

export const TransactionSummaryStatement = ({
  clientId,
  formValues,
  startDate,
  endDate
}: StatementProps) => {
  const investmentPlanNumbers: string[] = formValues.investments.map((inv) =>
    inv.investmentPlanNumber?.toString()
  );

  const { data } = useSuspenseQuery(
    getTransactionSummaryReport({
      clientId: clientId,
      planNumbers: investmentPlanNumbers,
      startDate: startDate,
      endDate: endDate
    })
  );

  const transactionSummary = data?.sort(
    (a, b) => Number(a.transactionSummary.planNumber) - Number(b.transactionSummary.planNumber)
  );

  const inclIRR = formValues?.statementOptions?.includes(StatementOption.inclIRR);

  return (
    <Suspense>
      {transactionSummary?.map((transaction, index) => (
        <TransactionSummaryDropdown
          key={index}
          index={index + 1}
          investmentCount={index + 1}
          investmentTotal={transactionSummary.length}
          transactionSummary={transaction}
          includeIRR={inclIRR !== undefined ? inclIRR : false}
        />
      ))}
    </Suspense>
  );
};
